$(function() {

	/*var $footer = $('#footer'),
		$app = $('#app');

	function update() {
		$footer[$app.height() < $(window).height() ? 'addClass' : 'removeClass']('sticky').addClass('visible');
	}

	$(window).scroll(update);
	$(window).resize(update);
	update();*/

});